import apiClient from "./apiClient"; // Asegúrate de que la ruta es correcta

const contactsEndpoint = "/contacts";

// Definimos las funciones como constantes, sin el 'export' individual
export const getAllContacts = async () =>
  apiClient.get(contactsEndpoint).then((res) => res.data);

export const getContactById = async (id) =>
  apiClient.get(`${contactsEndpoint}/${id}`).then((res) => res.data);

export const getContactsByFullName = async (fullName) =>
  apiClient
    .get(`${contactsEndpoint}/fullName/${fullName}`)
    .then((res) => res.data);

export const getContactsByMobileNumber = async (mobileNumber) =>
  apiClient
    .get(`${contactsEndpoint}/mobileNumber/${mobileNumber}`)
    .then((res) => res.data);

export const getContactsByEmail = async (email) =>
  apiClient.get(`${contactsEndpoint}/email/${email}`).then((res) => res.data);

export const getContactsByEmailNotifications = async (
  tagIds = [],
  contactTypes = [],
  typeOperator = "or",
  globalSearch = "",
  page = 1,
  limit = 10,
  tagsOperator = "or",
  consultantIds = [], // 1. Añadimos el nuevo parámetro
  adZones = [],
  reqZones = [],
) => {
  const params = new URLSearchParams({
    typeOperator,
    tagsOperator,
    page: page.toString(),
    limit: limit.toString(),
  });

  if (tagIds.length > 0) params.append("tags", tagIds.join(","));
  if (contactTypes.length > 0)
    params.append("contactTypes", contactTypes.join(","));
  if (globalSearch) params.append("globalSearch", globalSearch);

  // 2. Añadimos los consultores a la query string si existen
  if (consultantIds && consultantIds.length > 0) {
    params.append("consultantIds", consultantIds.join(","));
  }

  if (adZones.length > 0) params.append("adZones", adZones.join(","));
  if (reqZones.length > 0) params.append("reqZones", reqZones.join(","));

  try {
    const response = await apiClient.get(
      `${contactsEndpoint}/marketingCampaigns?${params.toString()}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching contacts by email notifications:", error);
    throw error;
  }
};

export const getAllContactIdsFiltered = async (
  tagIds = [],
  contactTypes = [],
  typeOperator = "or",
  globalSearch = "",
  tagsOperator = "or",
  consultantIds = [],
  adZones = [], // Actualizado
  reqZones = [], // Nuevo
) => {
  const params = new URLSearchParams({
    typeOperator,
    tagsOperator,
  });

  if (tagIds.length > 0) params.append("tags", tagIds.join(","));
  if (contactTypes.length > 0)
    params.append("contactTypes", contactTypes.join(","));
  if (globalSearch) params.append("globalSearch", globalSearch);
  if (consultantIds.length > 0)
    params.append("consultantIds", consultantIds.join(","));

  // Enviar zonas diferenciadas al backend
  if (adZones.length > 0) params.append("adZones", adZones.join(","));
  if (reqZones.length > 0) params.append("reqZones", reqZones.join(","));

  try {
    const response = await apiClient.get(
      `${contactsEndpoint}/filteredContactIds?${params.toString()}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all contact IDs:", error);
    throw error;
  }
};

export const getAllOwners = async () =>
  apiClient.get(`${contactsEndpoint}/owners`).then((res) => res.data);

export const createContact = async (form) =>
  // Axios convierte el objeto 'form' a JSON automáticamente
  apiClient.post(`${contactsEndpoint}/create`, form).then((res) => res.data);

export const updateContact = async (form) =>
  apiClient.put(`${contactsEndpoint}/edit`, form).then((res) => res.data);

export const contactReceiveEmail = async (form) =>
  apiClient
    .put(`${contactsEndpoint}/receiveEmails`, form)
    .then((res) => res.data);

export const deleteContact = async (id) =>
  apiClient.delete(`${contactsEndpoint}/delete/${id}`).then((res) => res.data);

// Mantenemos tu bloque de exportación original al final del archivo
